import React from "react";
import Styled from "styled-components";

import Layout from "../components/layout";
import { Container, Title } from "../components/page-styles";
import Contact, { Container as StaffCont } from "../components/staff-contact";

const StyledWrapper = Styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  @media screen and (max-width: 949px) {
    ${Title} {
      text-align: center;
    }
    > div {
      align-items: center;
      width: 100%;
    }
    ${StaffCont} {
      width: 100%;
      > a {
        text-align: center;
      }
    }
  }
`;
const StyledInner = Styled.div`
  margin-bottom: ${45 / 16}rem;
`;
const StaffDirectoryPage = () => (
  <Layout>
    <Container>
      <Title>Managing Partner</Title>
      <StyledWrapper>
        <StyledInner>
          <Contact
            name="Craig Noble"
            email="cnoble@ncatalent.com"
          />
        </StyledInner>
      </StyledWrapper>

      <Title>Film/Television/Theatre</Title>
      <StyledWrapper>
        <StyledInner>
          <Contact
            title="Agent"
            name="Rich Caplan"
            email="rcaplan@ncatalent.com"
          />
          <Contact
            title="Agent"
            name="Rick Gerrits"
            email="rgerrits@ncatalent.com"
          />
          <Contact
            title="Associate"
            name="Jackie Lyon"
            email="jlyon@ncatalent.com"
          />
        </StyledInner>
        <StyledInner>
          <Contact
            title="Agent"
            name="Sav Murthy"
            email="sav@ncatalent.com"
          />
          <Contact
            title="Agent"
            name="Michael Marino"
            email="mmarino@ncatalent.com"
          />
          <Contact
            title="Associate"
            name="Kordell Medas"
            email="kmedas@ncatalent.com"
          />
        </StyledInner>
      </StyledWrapper>

      <StyledWrapper>
        <StyledInner>
          <Title>Commercials</Title>
          <Contact
            title="Agent"
            name="Andrew Rosentsveig"
            email="arosentsveig@ncatalent.com"
          />
          <Contact
            title="Assistant"
            name="Blake Fitzpatrick"
            email="bfitzpatrick@ncatalent.com"
          />
        </StyledInner>
        <StyledInner>
          <Title>Voice & Animation</Title>
          <Contact
            title="Agent"
            name="Melissa Altro"
            email="maltro@ncatalent.com"
          />
          <Contact
            title="Assistant"
            name="Josh Zimel"
            email="jzimel@ncatalent.com"
          />
        </StyledInner>
      </StyledWrapper>

      <StyledWrapper>
      <StyledInner>
          <Title>Accounting</Title>
          <Contact name="Khushi Paul (CPA)" email="kpaul@ncatalent.com" />
          <Contact name="Parbaty Paul" email="ppaul@ncatalent.com" />
        </StyledInner>
        <StyledInner>
          <Title>Reception</Title>
          <Contact
            name="Jennifer Gaynor"
            email="jgaynor@ncatalent.com"
          />
        </StyledInner>
      </StyledWrapper>

      <StyledWrapper>
      <StyledInner>
          <Title>Studio</Title>
          <Contact
            name="Self-tapes / Voice Recordings"
            email="studio@ncatalent.com"
          />
        </StyledInner>
        {/*<StyledInner>*/}
        {/*  <Title>Reception</Title>*/}
        {/*  <Contact name="Jennifer Gaynor" email="jgaynor@ncatalent.com" />*/}
        {/*</StyledInner>*/}
      </StyledWrapper>
    </Container>
  </Layout>
);

export default StaffDirectoryPage;
